import moment from "moment";
import { BaseEntity } from ".";
import { IGet_characters_character_id_attributes_ok } from "../service/esiclient";
import { getCachedCharacterEntity } from "./CharacterEntityCache";

export class CharacterAttributesEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Character Attributes";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const id = this._id;
    const props: Partial<IGet_characters_character_id_attributes_ok> = this.props;
    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      if (props) {
        const characterEntity = await getCachedCharacterEntity(id);
        if (characterEntity != null) {
          entity.properties["owner"] = await characterEntity.toJson();
          entity.text = `Attributes for ${characterEntity?.props.name.toString()}`;
        } else {
          entity.text = "Attributes for (Unknown)";
        }
        if (props.last_remap_date) {
          const last_remap_date = moment(props.last_remap_date);
          entity.properties["last_remap_date"] = {
            type: Excel.CellValueType.formattedNumber,
            basicValue: last_remap_date.unix() / 86400 + 25569,
            numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
          };
        }
        if (props.accrued_remap_cooldown_date) {
          const accrued_remap_cooldown_date = moment(props.accrued_remap_cooldown_date);
          entity.properties["accrued_remap_cooldown_date"] = {
            type: Excel.CellValueType.formattedNumber,
            basicValue: accrued_remap_cooldown_date.unix() / 86400 + 25569,
            numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
          };
        }
      }
    }

    // Layouts
    entity.layouts = {
      card: {
        //title: { property: "name" },
      },
    };

    return entity;
  }
}
